<div class="audio-toggle-block" (mouseenter)="onEnter()" (mouseleave)="onLeave()">
    <button
            (click)="toggleAudio()"
            play-audio
            onEnterSound="btn_default_enter"
            onClickSound="btn_default_click"
            class="btn-icon audio-toggle"
            type="button"
    >
        <span class="icon" [ngClass]="[audioEnabled ? 'icon-audio-on' : 'icon-audio-off']"></span>
    </button>

    <div class="audio-volume-slider">
        <div class="slider-block">
            <mat-slider
                #audioVolumeSlider
                [vertical]="true"
                (input)="onVolumeChange(audioVolumeSlider.value)"
                [value]="currentVolume"
                [step]="1"
                [min]="0"
                [max]="10"
            ></mat-slider>
        </div>
    </div>

</div>

